module.exports = __webpack_public_path__ + "static/media/new-nepal-govt-logo.8fe29cfa.svg";